/* istanbul ignore file */
import { styled } from '@mui/material/styles';

import { rem, Theme, px } from '../../theme';
import { HorizontalRule } from '../HorizontalRule';

import {
    StyledSubMenuTextProperties,
    StyledLinkContainerProperties,
    StyledTextProperties,
} from './NavigationItem.types';

export const StyledListItem = styled('li')`
    /* stylelint-disable unit-allowed-list */
    height: ${({ theme }: { theme: Theme }) => theme.tggSpacing(rem(5), 12)};

    padding: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing([0, 0], [0, 6])};
`;

export const StyledLinkContainer = styled('a')<StyledLinkContainerProperties>`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: ${({ $leftIconExists, theme }) =>
        $leftIconExists
            ? theme.tggSpacing(rem(1.2), 0)
            : theme.tggSpacing(rem(4), 0)};

    color: ${({ theme }) =>
        theme.getRebrandingColor(
            theme.palette.common.blue,
            theme.palette.tgg.text.body.main,
        )};
    text-decoration: none;

    svg {
        margin-bottom: ${({ theme }: { theme: Theme }) =>
            theme.tggSpacing(0, 1)};
    }

    &:hover {
        text-decoration: underline;
    }

    ${({ theme }) => theme.breakpoints.up(375)} {
        margin-left: ${({ theme }) => theme.tggSpacing(rem(4), 0)};
    }
`;

export const StyledText = styled('span')<StyledTextProperties>`
    width: ${({ theme }) => theme.tggSpacing(rem(24.8), 64)};
    padding-top: ${({ theme }) => theme.tggSpacing(rem(1.4), 3)};
    padding-bottom: ${({ theme }) => theme.tggSpacing(rem(1), 3)};
    margin: ${({ theme }) =>
        theme.tggSpacing([0, rem(0.4), 0, rem(1)], [0, 2, 0, 2])};
    text-transform: ${({ $caseSensitive }) =>
        $caseSensitive ? 'none' : 'lowercase'};

    ${({ theme }) =>
        theme.isRebranding(
            theme.typography.bodySmall,
            theme.typography.bodyStandardRebrand,
        )};

    span {
        margin-right: ${({ theme }) => theme.tggSpacing(rem(0.3), 1)};

        &:hover {
            text-decoration: none;
        }
    }
`;

export const StyledChipSpan = styled('span')`
    ${({ theme }: { theme: Theme }) => `
        margin-left: ${theme.tggSpacing(rem(1), 2.5)};
    `}
`;

export const StyledSubMenuText = styled('span')<StyledSubMenuTextProperties>`
    ${({
        theme,
        $caseSensitive,
        $isSubMenuAlternativeItem,
    }: StyledSubMenuTextProperties & { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(px(15), 3)};
        padding-bottom: ${theme.tggSpacing(px(15), 3)};
        margin-left: ${
            $isSubMenuAlternativeItem
                ? theme.tggSpacing(rem(0.8), 3)
                : theme.tggSpacing(0, 2)
        };
        text-transform: ${$caseSensitive ? 'none' : 'lowercase'};
    `}

    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding(
            theme.typography.text_14,
            theme.typography.bodyStandardRebrand,
        )};
`;

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: ${theme.tggSpacing(rem(1.2), 0)};
        color: ${theme.palette.common.blue};
        cursor: pointer;

            & :hover {
                text-decoration: underline;
            }

        ${theme.breakpoints.up(375)} {
            margin-left: ${theme.tggSpacing(rem(4), 0)};
        }
    `}
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(27), 80)};
        margin: ${theme.tggSpacing([0, 0, 0, rem(4)], [0, 0, 0, 2])};
        background-color: ${theme.getRebrandingColor(theme.palette.grey['900'], theme.palette.tgg.border.rule.main)};

        ${theme.breakpoints.up(375)} {
            width: ${theme.tggSpacing(rem(32.5), 80)};
        }
    `}
`;
